import { render, staticRenderFns } from "./ReferencePage.vue?vue&type=template&id=2a4abc6f&scoped=true&"
import script from "./ReferencePage.vue?vue&type=script&lang=js&"
export * from "./ReferencePage.vue?vue&type=script&lang=js&"
import style0 from "./ReferencePage.vue?vue&type=style&index=0&id=2a4abc6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4abc6f",
  null
  
)

export default component.exports